"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteSearchServiceInstance = void 0;
const backendImport_1 = require("./backendImport");
const SocialMediaProxyService_1 = __importStar(require("@front/services/SocialMediaProxyService"));
const client_1 = require("@rws-framework/client");
let RouteSearchService = class RouteSearchService extends client_1.RWSService {
    constructor(digitalProxyService) {
        super();
        this.digitalProxyService = digitalProxyService;
    }
    getRouteUrl(routeName, routeParams) {
        for (const prefixedRoute of backendImport_1.backendRoutes) {
            const foundRoute = prefixedRoute.routes.find((r) => r.name === routeName);
            if (foundRoute) {
                const routePath = Array.isArray(foundRoute.path) ? foundRoute.path[0] : foundRoute.path;
                let url = `${prefixedRoute.prefix}${routePath}`;
                if (routeParams) {
                    for (const [key, value] of Object.entries(routeParams)) {
                        url = url.replace(`:${key}`, value);
                    }
                }
                return url;
            }
        }
        return null;
    }
    async callGatedBackend(routeName, routeParams, payload, method = 'POST') {
        const routeUrl = this.getRouteUrl(routeName, routeParams);
        return await this.digitalProxyService.proxyRequest(routeUrl, payload, method);
    }
    async callGatedBackendUpload(routeName, routeParams, file, payload, onProgress) {
        const routeUrl = this.getRouteUrl(routeName, routeParams);
        return await this.digitalProxyService.proxyUploadRequest(routeUrl, file, payload, onProgress);
    }
};
exports.RouteSearchServiceInstance = RouteSearchService;
exports.RouteSearchServiceInstance = RouteSearchService = __decorate([
    __param(0, SocialMediaProxyService_1.default),
    __metadata("design:paramtypes", [typeof (_a = typeof SocialMediaProxyService_1.DigitalProxyServiceInstance !== "undefined" && SocialMediaProxyService_1.DigitalProxyServiceInstance) === "function" ? _a : Object])
], RouteSearchService);
exports.default = RouteSearchService.getSingleton();
